import React from 'react';

export function BigHeader(props) {
    return (
        <h2>{props.headerText}</h2>
    )
}
export function SmallHeader(props) {
    return (
        <h4>{props.headerText}</h4>
    )
}
